export default {
  bind(el, binding, vnode) {
    function documentHandler(e) {
      if (el === e.target || el.contains(e.target) || e.target == el.previousElementSibling || el.previousElementSibling.contains(e.target)) {
        return false;
      }
      if (binding.expression) {
        binding.value(e);
      }
      if (window.getComputedStyle(el).display !== 'none') {
        vnode.context.menuToggle[binding.arg] = false;
      }
    }

    el.__vueClickOutside__ = documentHandler;
    document.addEventListener('click', documentHandler);
    window.addEventListener("scroll",documentHandler);
  },
  update() {
  },
  unbind(el, binding) {
    document.removeEventListener('click', el.__vueClickOutside__);
    window.removeEventListener("scroll",el.__vueClickOutside__);
    delete el.__vueClickOutside__;
  }
}



// WEBPACK FOOTER //
// ./src/directives/menuClickOut.js